var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 100,
    viewBox: "0 0 89 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.1749 0.000488281L80.142 89.99L44.0335 100L8.02445 90.0041L0 0.000488281H88.1749Z",
    fill: "#264DE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2648 84.2598L80.1295 7.35962H44.0874V92.3489L73.2648 84.2598Z",
    fill: "#2965F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3959 40.7407L19.3852 51.7792H44.0874V40.7407H18.3959Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0875 18.3982H44.0493H16.408L17.4114 29.4369H44.0875V18.3982Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0874 80.8935V69.4088L44.039 69.4217L31.7453 66.1021L30.9594 57.2983H24.9856H19.8784L21.4249 74.6305L44.0366 80.9077L44.0874 80.8935Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6421 51.779L56.3608 66.0952L44.0493 69.4182V80.9024L66.679 74.6306L66.845 72.7657L69.439 43.7047L69.7083 40.7406L71.7011 18.3982H44.0493V29.4369H59.6038L58.5994 40.7406H44.0493V51.779H57.6421Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/CSS.d3dafb854c741778dc28521873adc0c1.svg";
export { ForwardRef as ReactComponent };